import React from "react";

function GeneralSettings () {
  return (
    <div> this is list of GeneralSettings</div>
  )
}

export default GeneralSettings